<!--
* @description  参数1
* @fileName  origin
* @author userName
* @date 2024-01-04 17:05:57 @input="searchInput(text)"
!-->
<template>
  <div id="origin" v-clickoutside="closePanel" class="origin">
    <el-select readonly v-model="formData.Address" filterable :disabled="disabled" popper-class="cargo_info_select"
      :class="{
        'active-border': true,
        'input-error': inputErrorShow,
        'input-disabled': disabled,
      }" remote :remote-method="getAddress" :placeholder="this.textHtml ? '' : placeholderShow" no-match-text="No data"
      no-data-text="No data" style="width: 352px" @change="nextStep">
      <el-option v-for="item in AddressOptions" :key="item.label" :value="item.value" :label="item.label" />
    </el-select>
  </div>
</template>

<script>
import {
  GetDestCountry,
  GetCityByCountry,
  GetPortByCountry,
  GetLogList,
  ToppingLog,
  RemoveLog
} from '@/api/checkPrice'
import {
  message
} from '@/utils/message'
export default {
  name: 'Destination',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    disabled: {
      // 禁用输入
      type: Boolean,
      default: false
    },
    // 起运地选择海运/空运类型
    origintype: {
      type: Number,
      default: 0
    },
    searchKeysType: {
      // 搜索关键词
      type: String,
      required: true,
      default: 'City'
    },
    width: {
      type: String,
      required: false,
      default: '200'
    },
    placeholder: {
      // 输入框默认提示
      // type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      text: '', // 输入框显示文字
      textHtml: '',
      panelShow: false,
      inputErrorShow: false,
      panelOpen: false,
      placeholderShow: '您要运送到哪里？', // 输入框默认显示提示文字
      formData: {
        Type: 4,
        Country: '459155081518907809',
        CountryCode: 'US',
        Address: '',
        AddressCode: '',
        PortType: '',
        ZipCode: ''
      },
      allRules: {
        Type: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        Country: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        Address: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }]
      },
      TypeOptions: [
        {
          label: '仓库',
          value: 2
        },
        {
          label: '商业地址',
          value: 4
        },
        {
          label: '私人地址',
          value: 5
        }
      ],
      CountryOptions: [],
      AddressOptions: [],
      CheckPriceList: [],
      IsShow: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
    placeholder: {
      handler (val) {
        this.placeholderShow = val
      },
      // deep: true,
      immediate: true
    },
    panelShow (val) {
      // 获取组件的聚焦状态
      this.$emit('getFocusStatus', val)
    }
  },
  created () {
    // 实例被创建之后执行代码
    this.getCountry()
  },
  mounted () {
    // 页面进入时加载内容
    // 查价记录
    this.getQueryLog()
    this.$eventBus.$on('checkPrice', (data) => {
      this.CheckPrice(data)
    })
  },
  methods: {
    init (data) {
      this.formData = data
      GetDestCountry().then((res) => {
        if (res.code === 200) {
          this.CountryOptions = res.data.map((item) => ({
            label: item.fullName,
            value: item.id,
            code: item.code,
            logo: item.logo.url
          }))
          this.formData.CountryCode = this.CountryOptions.find(
            (item) => item.value === this.formData.Country
          ).code
        }
      })
      var type = this.TypeOptions.find(
        (p) => p.value === this.formData.Type
      ).label
      this.textHtml = `${type} | `

      const param = {
        keyword: data.ZipCode || data.Address,
        countryId: this.formData.Country
      }
      if (this.formData.Type === 1) {
        GetPortByCountry(param).then((res) => {
          if (res.code === 200) {
            var arr = res.data
            if (this.origintype != 0) {
              arr = arr.filter((item) => item.type == this.origintype)
            }
            this.AddressOptions = arr.map((item) => ({
              label: `${item.name},${item.code
                }`,
              value: item.id,
              type: item.type,
              code: item.code
            }))
            this.formData.AddressCode = this.AddressOptions.find(
              (item) => item.value === this.formData.Address
            ).code
            this.textHtml += `${this.formData.AddressCode}`
            this.$emit('next', this.formData)
          }
        })
      } else {
        GetCityByCountry(param).then((res) => {
          if (res.code === 200) {
            this.AddressOptions = res.data.map((item) => ({
              label: `${item.cityName},${item.countryName},${item.zipCode}`,
              value: item.id,
              code: item.cityName,
              zipCode: item.zipCode
            }))
            this.formData.AddressCode = this.AddressOptions.find(
              (item) => item.value === this.formData.Address
            ).code
            this.textHtml +=
              `${this.formData.AddressCode},${this.formData.CountryCode},${this.formData.ZipCode}`
            this.$emit('next', this.formData)
          }
        })
      }
    },
    removeLog (id) {
      RemoveLog(id).then((res) => {
        if (res.code === 200) {
          this.getQueryLog()
        }
      })
    },
    topping (item) {
      item.IsTop = item.IsTop === 0 ? 1 : 0
      ToppingLog({
        id: item.id,
        status: item.IsTop
      }).then((res) => {
        if (res.code === 200) {
          this.getQueryLog()
        }
      })
    },
    getQueryLog () {
      GetLogList(1).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.IsShow = true
            this.CheckPriceList = res.data
          } else {
            this.IsShow = false
            this.CheckPriceList = []
          }
          this.$forceUpdate()
        }
      })
    },
    // 打开下拉列表
    focusInput () {
      this.panelShow = true
      // 获取选中
      this.$nextTick(() => {
        this.$refs[`${this.searchKeysType}Input`].select()
      })
    },
    // 输入框失去焦点
    blurInput () {
      this.placeholderShow = this.placeholder
      if (!this.panelOpen) {
        this.closePanel(1)
      }
    },
    // 关闭下拉列表
    closePanel (val) {
      this.panelShow = false
      if (val == 1) {
        this.$emit('blur')
      }
    },
    nextStep () {
      if (this.formData.Type === 1) {
            var port = this.AddressOptions.find(
              (item) => item.value === this.formData.Address
            )
            this.formData.PortType = port.type
          }
          this.formData.CountryCode = this.CountryOptions.find(
            (item) => item.value === this.formData.Country
          ).code
          this.formData.AddressCode = this.AddressOptions.find(
            (item) => item.value === this.formData.Address
          ).code
          this.formData.ZipCode = this.AddressOptions.find(
            (item) => item.value === this.formData.Address
          ).zipCode
          this.getHtml()
          this.$emit('next', this.formData)
          this.closePanel(1)
    },
    getHtml () {
      let type = ''
      this.TypeOptions.forEach((res) => {
        if (res.value == this.formData.Type) {
          type = res.label
        }
      })
      this.textHtml = `${type} | `
      if (this.formData.Type === 1) {
        this.textHtml += `${this.formData.AddressCode}`
      } else if (this.formData.Type === 3) {
        this.textHtml += `${this.formData.Address}`
      } else {
        this.textHtml += `${this.formData.AddressCode},${this.formData.CountryCode},${this.formData.ZipCode}`
      }
    },
    typeChange (val) {
      this.AddressOptions = []
      this.formData.Address = ''
      this.getHtml()
      this.$emit('typeChange', val)
    },
    getCountry () {
      GetDestCountry().then((res) => {
        if (res.code === 200) {
          this.CountryOptions = res.data.map((item) => ({
            label: item.name,
            value: item.id,
            code: item.code
          }))
        }
      })
    },
    CheckPrice (item) {
      this.$emit('checkprice', item)
      this.closePanel(1)
    },
    ClearAll () {
      localStorage.removeItem('check_price_record')
      this.IsShow = false
    },
    getAddress (val) {
      if (this.formData.Country === '' || this.formData.Country === undefined) {
        message({
          message: 'Please select a country first',
          type: 'warning',
          duration: 1500
        })
        this.formData.Address = ''
        return
      }
      this.AddressOptions = []
      if (val === '') {
        return
      }
      const param = {
        keyword: val,
        countryId: this.formData.Country
      }
      if (this.formData.Type === 1) {
        GetPortByCountry(param).then((res) => {
          if (res.code === 200) {
            var data = res.data.filter(p => p.type == 2)
            this.AddressOptions = data.map((item) => ({
              label: `${item.name},${item.code
                }`,
              value: item.id,
              type: item.type,
              code: item.code
            }))
          }
        })
      } else {
        GetCityByCountry(param).then((res) => {
          if (res.code === 200) {
            this.AddressOptions = res.data.map((item) => ({
              label: `${item.cityName},${item.countryName},${item.zipCode}`,
              value: item.id,
              code: item.cityName,
              zipCode: item.zipCode
            }))
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.origin {
  .active-border-html {
    height: 28px;
    background: transparent;
    position: relative;
    font-size: 15x;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 550;
    color: #333333;
    line-height: 21px;
    padding: 0;
    text-align: left;
  }

  .active-border {
    ::v-deep input {
      outline: none;
      border: none;
      height: 28px;
      background: transparent;
      position: relative;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 550;
      color: #333333;
      line-height: 21px;
      padding: 0;
    }

    ::v-deep input::-webkit-input-placeholder {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 21px;
    }

    ::v-deep .input-error {
      &::-webkit-input-placeholder {
        color: #d83f3f;
      }
    }

    ::v-deep .input-disabled {
      color: #777;
    }

    ::v-deep .el-input__prefix {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 550;
      color: #333333;
      left: 0px;

      .suffix {
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 260px;
      }
    }
  }

  .by-panel {
    position: absolute;
    left: 0px;
    top: 68px;
    z-index: 10;
    width: 384px;
    height: auto; //360px;
    background: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: 1px solid rgba(221, 221, 221, 0.56);

    .origin-title {
      height: 32px;
      text-align: left;
      margin: 8px 16px;

      span:nth-of-type(1) {
        color: #e95506;
        margin-right: 10px;
      }

      span:nth-of-type(2) {
        font-size: 14px;
        font-family: D-DINExp, D-DINExp;
        font-weight: bold;
        color: #333333;
      }
    }

    .origin-form {
      margin: 0 16px;
      // height: 104px;
      border-bottom: 1px solid rgba(221, 221, 221, 0.56);

      .form-item {
        display: flex;

        ::v-deep .el-form-item {
          margin-bottom: 0;

          .el-form-item__label {
            float: left;
            padding: 0;
            margin-top: 16px;
          }

          .el-input__inner {
            height: 40px !important;
          }
        }

        .flex-width_1 {
          margin-right: 16px;
        }

        .nextStepActive {
          background: #3370ff !important;
        }

        .nextStep {
          width: 88px;
          height: 32px;
          background: #3370ff;
          border-radius: 8px;
          color: #ffffff;
          border-radius: 8px;
          line-height: 32px;
          margin: 16px 0;

          &:hover {
            cursor: pointer;
            background: #3370ff !important;
          }

          &:active {
            cursor: pointer;
            background: #3370ff !important;
          }
        }
      }
    }

    .recent-search {
      margin: 8px 16px 0;
      text-align: left;

      span:nth-of-type(1) {
        font-size: 13px;
        font-family: D-DINExp, D-DINExp;
        font-weight: bold;
        color: #333333;
        margin-right: 8px;
      }

      span:nth-of-type(2) {
        font-size: 12px;
        font-family: D, D;
        font-weight: normal;
        color: #027ffc;
      }
    }

    .no-login {
      margin: 18px 16px 0;
      text-align: left;

      button {
        width: 88px;
        height: 40px;
      }

      p {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }

    .not-data {
      margin: 16px;
      width: 760px;
      height: 96px;
      background: rgba(221, 221, 221, 0.24);
      border-radius: 8px;

      img {
        margin: 16px 0 -10px;
      }

      p {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #aaaaaa;
      }
    }

    .search-list {
      display: flex;
      height: 40px;
      margin: 3px 8px;
      padding: 0 8px;
      align-items: center;

      &:hover {
        background: rgba(233, 85, 6, 0.04) !important;
        border-radius: 8px;

        .eidt-icon {
          display: block;
          margin: 0 8px;
          cursor: pointer;
        }
      }

      .eidt-icon {
        display: none;
      }

      .el-icon-right {
        margin-right: 8px;
      }

      .city {
        font-size: 14px;
        font-family: D, D;
        font-weight: normal;
        color: #333333;
        margin: 0 8px;
      }

      .gray {
        font-size: 14px;
        font-family: D, D;
        font-weight: normal;
        color: #777777;
        margin-right: 24px;
      }
    }
  }
}
</style>
